<lvr-field [label]="label()" lvrPadding>
	<mat-form-field lvrInput [attr.aria-label]="label()">
		<input
			#searchInput
			#searchTrigger="matAutocompleteTrigger"
			matInput
			autocomplete="off"
			[placeholder]="'base.field.search_placeholder' | transloco"
			[disabled]="isDisabled()"
			[value]="displayText()"
			(focus)="onFocus(); searchTrigger.openPanel()"
			(input)="onSearch($event); searchTrigger.openPanel()"
			(blur)="onBlur()"
			[matAutocomplete]="searchAutocomplete"
		/>
		<!-- Clear search button -->
		@if (focused() && filterText()) {
			<button
				mat-icon-button
				matSuffix
				type="button"
				aria-label="Suche löschen"
				(mousedown)="$event.preventDefault()"
				(click)="clearSearch()"
			>
				<mat-icon aria-hidden="true">close</mat-icon>
			</button>
		}
	</mat-form-field>
</lvr-field>

<mat-autocomplete
	#searchAutocomplete="matAutocomplete"
	[autoActiveFirstOption]="false"
	[hideSingleSelectionIndicator]="true"
	[displayWith]="displayWithBranch"
	(optionSelected)="onOptionSelected($event.option.value, searchInput)"
>
	@for (branch of filteredBranches(); track trackById($index, branch)) {
		<mat-option [value]="branch" (mousedown)="$event.preventDefault()">
			<div class="option">
				<mat-checkbox [checked]="isBranchSelected(branch.id)">
					<div class="text-block">
						<span class="branch-name"> {{ branch.name }} </span>
						<span class="branch-info">
							@if (branch.isMainInstitution) {
								{{ 'institution.persons.edit.responsibleBranches.main_branche' | transloco }}
							} @else {
								{{ branch.address?.postalCodeAndCity }} - {{ branch.address?.streetAndHouseNumber }}
							}
						</span>
					</div>
				</mat-checkbox>
			</div>
		</mat-option>
	} @empty {
		<mat-option disabled>
			{{ 'institution.persons.edit.responsibleBranches.no_branche_suggestion' | transloco }}
		</mat-option>
	}
</mat-autocomplete>

@if (!focused() && selectedBranches().length > 0) {
	<ul class="selected-tasks">
		@for (branch of selectedBranches(); track branch.id) {
			<li>
				<mat-checkbox [checked]="true" (change)="toggle(branch.id)">
					<div class="text-block">
						<span class="branch-name">{{ branch.name }}</span>
						<span class="branch-info">
							@if (branch.isMainInstitution) {
								{{ 'institution.persons.edit.responsibleBranches.main_branche' | transloco }}
							} @else {
								{{ branch.address?.postalCodeAndCity }} - {{ branch.address?.streetAndHouseNumber }}
							}
						</span>
					</div>
				</mat-checkbox>
			</li>
		}
	</ul>
}
